// @flow

import { useEffect, useState } from 'react';

// Debounce `value` updates every `delay`.
// Ref. https://usehooks.com/useDebounce
function useDebounce<V>(value: V, delay: number): V {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export default useDebounce;
